import { jsx as _jsx } from "react/jsx-runtime";
export const StepIndicator = ({ totalSteps, currentStep }) => {
    const stepsArr = Array.from({ length: totalSteps }, (_, i) => i + 1);
    return (_jsx("div", { className: 'flex gap-6 items-center', children: stepsArr.map((step) => (_jsx("div", { className: `flex items-center justify-center rounded-full w-6 h-6 ${currentStep === step ? 'bg-purple-75' : ''}`, children: _jsx("div", { className: `rounded-full w-3.5 h-3.5 ${currentStep === step ? 'bg-purple-500' : 'bg-neutral-200'}` }) }, step))) }));
};
